import Document, { Html, Head, Main, NextScript, DocumentContext } from 'next/document';
import { getGlobalStyles } from './getGlobalStyles';

interface ExtendedDocumentProps {
  pageProps?: {
    rtl?: string;
    rtlEnable?: boolean;
    model?: { language?: string };
  };
}

export default class BaseDocument extends Document<ExtendedDocumentProps> {
  static override async getInitialProps(ctx: DocumentContext) {
    const initialProps = await Document.getInitialProps(ctx);
    return { ...initialProps };
  }

  renderHead(forceDirection?: 'rtl' | 'ltr') {
    const { pageProps } = this.props;

    const direction = forceDirection ?? (pageProps?.rtlEnable ? 'rtl' : pageProps?.rtl ?? 'ltr');

    const isRTL = direction.toLowerCase() === 'rtl';
    const isProd = process.env['NODE_ENV'] === 'production';
    const deployedEnvType = process.env['DEPLOYED_ENV_TYPE'] || '';
    const assetDomain = process.env['NEXT_PUBLIC_ASSET_DOMAIN'] || '';
    const assetPrefix = process.env['NEXT_GLOBAL_ASSET_PREFIX'] || '';
    // Pass undefined when both are missing to trigger fallback in getGlobalStyles
    const assetUrl = assetDomain || assetPrefix ? `${assetDomain}${assetPrefix}` : undefined;

    const globalCss = getGlobalStyles({
      assetUrl,
      isProd,
      rtl: isRTL,
      deployedEnvType,
    });

    return (<link rel="stylesheet" href={globalCss} />);
  }

  renderBody() {
    return (
      <>
        <Main />
        <NextScript />
      </>
    );
  }

  override render() {
    return (
      <Html>
        <Head>{this.renderHead()}</Head>
        <body>{this.renderBody()}</body>
      </Html>
    );
  }
}
